// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33uFO","title":"styles_title__3XVj2"};